<template>
	<div class="d-flex flex-column video-container">
		<section class="video-player flex-shrink-0">
			<img
				src="../../assets/img/av-icn/video-screen.png"
				class="videoimg"
				alt=""
			/>
			<div class="control-top">
				<a
					href="#"
					class="avbtn btn"
					data-toggle="tooltip"
					data-placement="right"
					title="Back To Home"
					><img src="../../assets/img/av-icn/back button.svg" alt="" />
				</a>
			</div>
			<div class="control-bottom">
				<div class="row d-flex align-items-center mb-2">
					<div class="col mr-auto">
						<div class="progress hight4 control">
							<div
								class="progress-bar w-75"
								role="progressbar"
								aria-valuenow="75"
								aria-valuemin="0"
								aria-valuemax="100"
							></div>
						</div>
					</div>
					<div class="col-1 ml-auto pl-0 time">
						01:43:62
					</div>
				</div>

				<div class="d-flex justify-content-between">
					<div>
						<ul class="list-unstyled d-flex">
							<li>
								<a href="#" class="avbtn btn"
									><img src="../../assets/img/av-icn/play.svg" alt="" />
								</a>
							</li>
							<li>
								<a href="#" class="avbtn btn"
									><img src="../../assets/img/av-icn/rewind.svg" alt="" />
								</a>
							</li>
							<li>
								<a href="#" class="avbtn btn"
									><img src="../../assets/img/av-icn/fast forward.svg" alt="" />
								</a>
							</li>
							<li class="dropdown dropup show">
								<a
									href="#"
									class="avbtn btn "
									role="button"
									id="dropdownMenuLink"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
									><img src="../../assets/img/av-icn/volume-up.svg" alt="" />
								</a>
								<div
									class="dropdown-menu volume"
									aria-labelledby="dropdownMenuLink"
								>
									<a class="dropdown-item" href="#">
										<img src="../../assets/img/av-icn/volume-bar.svg" alt="" />
									</a>
								</div>
							</li>
							<li>void</li>
						</ul>
					</div>
					<div>
						<ul class="list-unstyled d-flex">
							<li>
								<a
									href="#"
									class="avbtn btn help-outline"
									data-toggle="tooltip"
									data-placement="top"
									title="something wrong? Tell Us"
									><img src="../../assets/img/av-icn/help_outline.svg" alt="" />
								</a>
							</li>

							<li class="dropdown dropup show">
								<a
									href="#"
									class="avbtn btn "
									role="button"
									id="dropdownMenuLinka"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
									><img src="../../assets/img/av-icn/skip-next.svg" alt="" />
								</a>
								<div
									class="dropdown-menu data-result"
									aria-labelledby="dropdownMenuLinka"
								>
									<div class="w-100 text-white">
										<h5>Next Episode</h5>
										<div class="media">
											<div class="card episode mr-2">
												<div class="card-img-top">
													<img
														class="card-img-top"
														src="../../assets/img/video-img.png"
														alt=""
													/>
													<a href="#" class="btn-play"
														><i class="fa fa-play"></i
													></a>
												</div>
											</div>
											<div class="media-body">
												<h6 class="mt-0">
													Episode 1 <span class="float-right">48 min</span>
												</h6>
												Cras sit amet nibh libero, in gravida nulla. Nulla vel
												metus scelerisque
											</div>
										</div>
									</div>
								</div>
							</li>
							<li class="dropdown dropup show">
								<a
									href="#"
									class="avbtn btn "
									role="button"
									id="dropdownMenuLink"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
									><img src="../../assets/img/av-icn/Playlist.svg" alt="" />
								</a>
								<div
									class="dropdown-menu data-result"
									aria-labelledby="dropdownMenuLink"
								>
									<div class="w-100">
										<h5 class="text-white">Grey</h5>
										<div class="">
											<a class="dropdown-item" href="#">
												<i class="fa fa-check" aria-hidden="true"></i> Season 1
											</a>
											<a class="dropdown-item of" href="#">
												Season 2
											</a>
											<a class="dropdown-item of" href="#">
												Season 3
											</a>
										</div>
									</div>
								</div>
							</li>
							<li class="dropdown dropup show">
								<a
									href="#"
									class="avbtn btn "
									role="button"
									id="dropdownMenuLink"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
									><img src="../../assets/img/av-icn/subtitles.svg" alt="" />
								</a>
								<div
									class="dropdown-menu data-result"
									aria-labelledby="dropdownMenuLink"
								>
									<div class="d-flex w-100">
										<div class="">
											<a class="dropdown-item" href="#">
												Audio
											</a>
											<a class="dropdown-item" href="#">
												<i class="fa fa-check" aria-hidden="true"></i> English
											</a>
											<a class="dropdown-item of" href="#">
												<i class="fa fa-check" aria-hidden="true"></i>Yoruba
											</a>
											<a class="dropdown-item of" href="#">
												<i class="fa fa-check" aria-hidden="true"></i> lgbo
											</a>
										</div>
										<div class="">
											<a class="dropdown-item" href="#">
												Subtitles
											</a>
											<a class="dropdown-item" href="#">
												<i class="fa fa-check" aria-hidden="true"></i>
												English[CC]
											</a>
											<a class="dropdown-item of" href="#">
												<i class="fa fa-check" aria-hidden="true"></i> Off
											</a>
											<a class="dropdown-item of" href="#">
												<i class="fa fa-check" aria-hidden="true"></i> sYoruba
											</a>
										</div>
									</div>
								</div>
							</li>
							<li>
								<a href="#" class="avbtn btn"
									><img src="../../assets/img/av-icn/cast.svg" alt="" />
								</a>
							</li>
							<button class="avbtn btn">
								<img src="../../assets/img/av-icn/fullscreen.svg" alt="" />
							</button>
						</ul>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Category from "@/components/Category.vue";

export default {
	name: "VideoplayerSeries",
	components: {
		Category,
	},
	computed: {
		showplay() {
			if (this.$store.state.globalconfigs.enable_play == "false") {
				return false;
			} else {
				return true;
			}
		},
	},
	filters: {
		trimdis: function(value) {
			return value.slice(0, 80) + "...";
		},
	},
	mounted() {
		//  this.$store.commit('setLoader', true);
		window.scroll(0, 0);
	},

	beforeRouteEnter(to, from, next) {
		//  this.$store.commit('setLoader', false);
		next();
	},

	data() {
		return {
			category_data: {},
			showVideo: false,
			currentVideo: {},
			currentCat: "",
			options: null,
		};
	},
	methods: {
		my_favourite() {
			for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
				var item = this.$store.state.user.mylist[i];
				if (item.id == this.currentVideo.id) return true;
			}
			return false;
		},
		handleFav() {},
	},
	created() {
		this.$store.commit("showPopup", false);
		this.$store.commit("showdefaultnav", false);
		this.$store.commit("showdefaultFooter", false);
		document.body.requestFullscreen();
		if (this.$store.state.user.logedin == false) {
			this.$store.commit("setLoader", false);
			this.$router.push("/login");
			return false;
		}
	},
};
</script>

<style scoped>
.video {
	position: absolute;
	width: 100%;
	height: 100%;
}
.details div {
	box-sizing: border-box;
	content: "";
}
.details {
	position: relative;
	width: 100%;
	max-width: 100%;
	margin: 0 auto;
	padding-bottom: 100px;
}
.current-video {
	width: 100%;
}
.cover-image {
	position: relative;
	width: 100%;
	min-height: 100vh;
	background-size: 100% 100%;
	border-bottom: 1px solid #000;
	opacity: 0.5;
}
.video-card {
	background-color: #000000;
	width: 80%;
	margin: 0 auto;
	color: #ffff;
	padding: 20px;
	margin-top: 16px;
	/*box-shadow: 0px 1px 10px 11px rgba(88, 86, 86, 0.5);*/
}
.video-card p {
	margin-bottom: 40px;
}
.recent-carousel {
	margin: 0 auto;
	width: 80%;
	position: relative;
	padding-top: 100px;
}
.gradient-div {
	position: absolute;
	width: 100%;
	bottom: 0px;
	border: 5px solid rgb(0, 0, 0);
	box-shadow: 0px -20px 50px 50px rgb(0, 0, 0);
}
.watchnow {
	padding: 10px;
	font-size: 1.2rem;
	border-radius: 3px;
	cursor: pointer;
	background: transparent;
	color: #fff;
	border: 1px solid #fff;
	text-align: center;
}
@media only screen and (max-width: 600px) {
	.cover-image {
		min-height: 50vh;
	}
	.video-card {
		background-color: #000000;
		width: 90%;
	}
}
</style>
